(function () {
    'use strict';

    angular.module('app.customer', []);
})();